import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesDetailSection from '../components/ServicesDetailSection';
import QuoteFormSection from '../components/QuoteFormSection';
import FeaturedProjectsSection from '../components/FeaturedProjectsSection';
import ProjectGallerySection from '../components/ProjectGallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import CallToActionSection from '../components/CallToActionSection';
import Footer from '../components/Footer';
export function HomePage() {
  return <>
      <div id="hero" data-id="element-749">
        <HeroSection data-id="element-750" />
      </div>
      <div id="about" data-id="element-751">
        <AboutSection data-id="element-752" />
      </div>
      <div id="services" data-id="element-753">
        <ServicesDetailSection data-id="element-754" />
      </div>
      <div id="work" data-id="element-755">
        <ProjectGallerySection data-id="element-756" />
      </div>
      <div id="contact" data-id="element-757">
        <QuoteFormSection data-id="element-758" />
      </div>
      <FeaturedProjectsSection data-id="element-759" />
      <div id="testimonials" data-id="element-760">
        <TestimonialsSection data-id="element-761" />
      </div>
      <WhyChooseUsSection data-id="element-762" />
      <CallToActionSection data-id="element-763" />
      <Footer data-id="element-764" />
    </>;
}